import { variables } from "../common-variables.js";
export const burger = () => {
  const btns = document.querySelectorAll(".header-mobile-burger");
  const menus = document.querySelectorAll(".header-menu-mob");
  btns.forEach((btn) => {
    btn.addEventListener("click", () => {
      btn.classList.toggle("active");
      btn.classList.remove("hover");
      toggleMenu();
    });
  });
  const toggleMenu = () => {
    menus.forEach((menu) => {
      menu.classList.toggle("scale-y-0");
    });
    variables.page.classList.toggle("active");
    document.querySelector("body").classList.toggle("overflow-hidden");
  };

  const menuHeight = () => {
    menus.forEach((menu) => {
      menu.style.height = `${window.innerHeight - variables.header.offsetHeight}px`;
    });
  };
  menuHeight();
  window.addEventListener("resize", () => {
    menuHeight();
  });
};
